import { useAuthStore } from "~/store/authentication/useAuthStore";
import { isDemoOrganizationId } from "~/lib/demo-organization";

/** True while signed in to the protected sales-demo organization. */
export function useIsDemoOrganization(): boolean {
  const organizationId = useAuthStore(
    (s) => s.profile?.userOrganizations?.[0]?.organizationId,
  );
  return isDemoOrganizationId(organizationId);
}
